import { challengesForm } from '../../modules/challengesForm';

export const challengesCreate = () => {
  challengesForm();
};
